import { render, staticRenderFns } from "./Index_p.vue?vue&type=template&id=5189192e&scoped=true"
import script from "./Index_p.vue?vue&type=script&lang=js"
export * from "./Index_p.vue?vue&type=script&lang=js"
import style0 from "./Index_p.vue?vue&type=style&index=0&id=5189192e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5189192e",
  null
  
)

export default component.exports